import { AndroidMobileAppDrawer } from '@/features/authorization/components/AndroidMobileAppDrawer'
import { InviteCodeProvider } from '@/features/authorization/components/InviteCodeProvider'
import styles from '@/pages/LoginPage.module.css'
import { GlassBox, Page } from '@/ui-kit'
import { useState } from 'react'
import { Outlet } from 'react-router-dom'
import { CookiesDialog } from './CookiesDialog'
import { Footer } from './Footer'
import { Header } from './Header'
import { HeaderAuthorized } from './HeaderAuthorized'
import { NavigationSidebar } from './NavigationSidebar'
import { WebviewJwtFromUrl } from './WebviewJwtFromUrl'

export const RouteLayoutWebview = () => (
  <WebviewJwtFromUrl>
    <main className="flex min-h-screen flex-1 flex-col bg-[var(--colorBackground)] pt-[env(safe-area-inset-top)] pr-[env(safe-area-inset-right)] pb-[env(safe-area-inset-bottom)] pl-[env(safe-area-inset-left)]">
      <Outlet />
    </main>
  </WebviewJwtFromUrl>
)

export const RouteLayoutWithLeftSideMenu = () => {
  const [isMenuOpened, setIsMenuOpened] = useState(false)

  return (
    <InviteCodeProvider>
      <AndroidMobileAppDrawer />
      <HeaderAuthorized isMenuOpened={isMenuOpened} setIsMenuOpened={setIsMenuOpened} />
      <div className="flex flex-1">
        <NavigationSidebar isMenuOpened={isMenuOpened} setIsMenuOpened={setIsMenuOpened} />
        <div className="flex flex-grow flex-col">
          <main
            className={`max-mobile:max-w-[unset] flex max-w-[calc(100vw-225px)] flex-1 flex-grow flex-col justify-between`}
          >
            <Outlet />
          </main>
          <Footer className="mt-[72px]" />
        </div>
      </div>
      <CookiesDialog />
    </InviteCodeProvider>
  )
}

export const RouteLayout = () => (
  <InviteCodeProvider>
    <Header />
    <main className={`flex flex-1 flex-col justify-between`}>
      <Page className="max-mobile:min-h-[600px] min-h-[720px] items-center justify-center">
        <div className={styles.background} />
        <div className="max-mobile:pt-[100px] -mt-24 min-h-[352px] w-full max-w-[400px] min-w-[340px]">
          <GlassBox className="h-full">
            <div className="flex flex-col p-10 pt-8">
              <Outlet />
            </div>
          </GlassBox>
        </div>
      </Page>
    </main>
    <Footer className="absolute bottom-0" />
    <AndroidMobileAppDrawer />
    <CookiesDialog />
  </InviteCodeProvider>
)
